import React from 'react';
import PropTypes from 'prop-types';
import { capitalize as _capitalize } from 'lodash';
import classNames from 'classnames/bind';
import { Col } from '@saucelabs/sl-component-grid';
import { ManualList, ManualListHeader, ManualListItem } from '@saucelabs/sl-component-manual-list';
import PlatformIcon from '@saucelabs/sl-component-platform-icon';
import { sortVersions } from '@saucelabs/sl-util-helpers';

import Styles from './DesktopBrowserConfiguratorPlatform.styles';

const context = classNames.bind(Styles);


const getBrowserLabel = (browser) => {
  const browserLabels = {
    chrome: 'Chrome',
    firefox: 'Firefox',
    opera: 'Opera',
    edge: 'Edge',
    safari: 'Safari',
    iexplore: 'IE',
  };

  return browserLabels[browser] || _capitalize(browser);
};

const DesktopBrowserConfiguratorPlatform = ({
  currentVersion,
  currentPlatform,
  onChange,
  platformName,
  versions,
}) => {
  const sortedVersions = Object.keys(versions).sort(sortVersions);
  const active = currentPlatform === platformName;
  const combinedClasses = context('default', {
    active,
  });

  return (
    <Col
      key={platformName}
      sm
      xs={12}
    >
      <div className={combinedClasses}>
        <ManualListHeader
          active={active}
          Icon={<PlatformIcon name={platformName} />}
          label={getBrowserLabel(platformName)}
        />
        <ManualList>
          {sortedVersions.map((version) => {
            const onClick = (event) => {
              event.preventDefault();
              event.stopPropagation();

              return onChange({
                platform: platformName,
                version,
              });
            };

            return (
              <ManualListItem
                key={`${platformName}-${version}`}
                active={currentVersion === version && active}
                name={version}
                onClick={onClick}
              />
            );
          })}
        </ManualList>
      </div>
    </Col>
  );
};

DesktopBrowserConfiguratorPlatform.propTypes = {
  currentPlatform: PropTypes.string.isRequired,
  currentVersion: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  platformName: PropTypes.string.isRequired,
  versions: PropTypes.object.isRequired,
};

export default DesktopBrowserConfiguratorPlatform;
